import { getApiRequest } from 'api/index';
import { IGetActionCreateResponse } from 'types/groupActions';

export const getActionCreate = (): Promise<IGetActionCreateResponse> => {
    return getApiRequest(`/actions/`);
};
